import { getBasicContentSchema } from '@/lib/zy-tiptap-utils';
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ZyClassicLabInstructionNodeView } from './zyclassiclab-instruction-node-view';
import ZyClassicLabNodeView from './zyclassiclab-node-view';

export const ZyClassicLabNodeHeadless = Node.create({
    name: 'zyClassicLab',

    content: 'zyClassicLabInstruction',

    group: 'block',

    draggable: true,

    isolating: true,

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => element.getAttribute('id'),
                renderHTML: attributes => {
                    if (!attributes.id) {
                        return {};
                    }
                    return { id: attributes.id };
                },
            },
        };
    },

    parseHTML() {
        return [{ tag: 'zyClassicLab' }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['zyClassicLab', HTMLAttributes, 0];
    },
});

export const ZyClassicLabInstructionNodeHeadless = Node.create({
    name: 'zyClassicLabInstruction',

    content: function () {
        return getBasicContentSchema();
    },

    group: 'block',

    defining: true,

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => element.getAttribute('id'),
                renderHTML: attributes => {
                    if (!attributes.id) {
                        return {};
                    }
                    return { id: attributes.id };
                },
            },
        };
    },

    parseHTML() {
        return [{ tag: 'zyClassicLabInstruction' }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['zyClassicLabInstruction', HTMLAttributes, 0];
    },
});

export const ZyClassicLabInstructionNode = ZyClassicLabInstructionNodeHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyClassicLabInstructionNodeView);
    },
});

export const ZyClassicLabNode = ZyClassicLabNodeHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyClassicLabNodeView);
    },
});
